import { inject } from "@angular/core";
import { signalStore, withMethods, patchState, withHooks } from "@ngrx/signals";
import { withEntities, setAllEntities } from "@ngrx/signals/entities";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, tap, switchMap, Observable } from "rxjs";
import { withRequestStatus, setPending, setFulfilled } from "../extensions/request-status.feature";
import { SpinWheelMilestoneViewModel } from "@playcharge/common/models/backend/spin-wheel/spin-wheel-milestone-view-model";
import { ApiSpinWheelService } from "../../services/api-spin-wheel.service";
import { SpinWheelEditModel } from "@playcharge/common/models/backend/spin-wheel/backoffice/spin-wheel-edit-model";

export type SpinWheelStore = InstanceType<typeof SpinWheelStore>;

export const SpinWheelStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<SpinWheelMilestoneViewModel>(),
    withRequestStatus(),
    withMethods((store, apiSpinWheelService = inject(ApiSpinWheelService)) => ({
        loadMilestones: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiSpinWheelService.getAll().pipe(
                        tap((milestones) => {
                            patchState(store, setAllEntities(milestones));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        updateMilestones(model: SpinWheelEditModel): Observable<SpinWheelMilestoneViewModel[]> {
            return apiSpinWheelService.updateMilestones(model).pipe(
                tap((milestones) => {
                    patchState(store, setAllEntities(milestones));
                }),
            );
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadMilestones();
        },
    })),
);
